import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Utils, fetchWithAuth, canAny, getMarketingUrl } from '../../utils';
const AppSetting = ({ changeSidebar, currentSidebar }) => {
	const [step, setStep] = useState(1)
	const [appList, setAppList] = useState([]) // eslint-disable-line no-unused-vars
	const [fileName, setFileName] = useState("");
	const [activeApp, setActiveApp] = useState({}) // eslint-disable-line no-unused-vars
	const [jsonContent, setJsonContent] = useState(null);
	const [randomStr, setRandomStr] = useState("")
	const [appConfigType, setAppConfigType] = useState(2)
	const [appConfigTypeAlert, setAppConfigTypeAlert] = useState(false)
	const [showJsonAlert, setShowJsonAlert] = useState(false) // eslint-disable-line no-unused-vars
	const [jsonName, setJsonName] = useState(null)
	const [appExist, setAppExist] = useState(false)
	const navigate = useNavigate()
	const location = useLocation()
	const { id, channel_type } = useParams();
	/** Platforms Settings/Activate — keep app menu. NewApp/onboarding — hide menu (wizard). */
	const fromPlatform = Boolean(location.state?.fromPlatform);




	useEffect(() => {
		if (typeof changeSidebar === "function") {
			if (fromPlatform) {
				changeSidebar("dashboardSidebar", 0);
			} else {
				changeSidebar("defaultSidebar", 1);
			}
		} else {
			localStorage.setItem("thirdSidebar", fromPlatform ? "0" : "1");
		}
		fetchWithAuth(Utils.baseurl + 'getbyid/application', {
			method: 'POST',
			body: JSON.stringify({ id: id }),
		})
			.then((response) => response.json())
			.then(async (result) => {
				if (result.status) {
					const details = Array.isArray(result.data?.applicationDetails)
						? result.data.applicationDetails
						: [];
					let data = details.find(item =>
						item.applicationId === parseInt(result.data.id) && item.channel_type === parseInt(channel_type)
					);

					if (data && data.json_name) {
						setAppExist(true)
					}

					if (data && data.app_id) {
						setRandomStr(data.app_id)
					}

					if (data) {
						setJsonName(data.json_name)
						setAppConfigType(data.app_config_type)
					} else {
						// Set default appConfigType to 2 for channel_type 2 (React Native only)
						if (parseInt(channel_type) === 2) {
							setAppConfigType(2)
						}
					}

				} else {
					toast.error(result.message)
				}
			})
			.catch((error) => console.error(error));

		// /get-organizations
		const user = JSON.parse(localStorage.getItem('userData'));

		if (user) {

			fetchWithAuth(Utils.baseurl + 'get-organizations', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ userId: user.id }),
			})
				.then((response) => response.json())
				.then(async (result) => {
					if (result.status) {
						setAppList(result.data)

					} else {
						toast.error(result.message)
					}
				})
				.catch((error) => console.error(error));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id, channel_type, fromPlatform]);

	// eslint-disable-next-line no-unused-vars
	function handleShowOption() {
		// Reserved for future use
	}

	// eslint-disable-next-line no-unused-vars
	function saveSecondStep() {

	}

	const handleFileUpload = (event) => {
		const file = event.target.files[0];
		if (file && file.type === 'application/json') {
			setFileName(file.name);
			const reader = new FileReader();

			// Read the file content
			reader.onload = (e) => {
				try {
					const json = JSON.parse(e.target.result);  // Parse JSON content
					setJsonContent(json);
				} catch (err) {
					toast.error('Invalid JSON file.');
				}
			};

			reader.readAsText(file); // Read file as text
		} else {
			toast.warning('Please upload a valid JSON file.');
		}
	};

	const storedApplication = localStorage.getItem('application');
	useEffect(() => {
		try {
			const parsed = JSON.parse(localStorage.getItem('application') || 'null');
			const list = Array.isArray(parsed) ? parsed : [];
			setActiveApp(list.find((item) => item?.is_active === 1) || {});
		} catch {
			setActiveApp({});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [storedApplication]);

	const canManagePlatform = canAny(["settings.platform.manage", "apps.add", "apps.change_status"]);


	const validateServiceAccountJSON = (json) => {
		// Required fields for Firebase service account JSON
		const requiredFields = [
			'type',
			'project_id',
			'private_key_id',
			'private_key',
			'client_email',
			'client_id',
			'auth_uri',
			'token_uri',
			'auth_provider_x509_cert_url',
			'client_x509_cert_url'
		];

		// Check if all required fields exist
		const missingFields = requiredFields.filter(field => !json.hasOwnProperty(field));

		if (missingFields.length > 0) {
			return {
				isValid: false,
				message: `Invalid service account JSON. Missing required fields: ${missingFields.join(', ')}`
			};
		}

		// Validate type field
		if (json.type !== 'service_account') {
			return {
				isValid: false,
				message: 'Invalid service account JSON. The "type" field must be "service_account".'
			};
		}

		// Validate private_key format
		if (!json.private_key.includes('BEGIN PRIVATE KEY') || !json.private_key.includes('END PRIVATE KEY')) {
			return {
				isValid: false,
				message: 'Invalid service account JSON. The private_key format is incorrect.'
			};
		}

		// Validate client_email format
		if (!json.client_email.includes('@') || !json.client_email.includes('.iam.gserviceaccount.com')) {
			return {
				isValid: false,
				message: 'Invalid service account JSON. The client_email format is incorrect.'
			};
		}

		// Validate URIs
		if (!json.auth_uri.startsWith('https://') || !json.token_uri.startsWith('https://')) {
			return {
				isValid: false,
				message: 'Invalid service account JSON. The auth_uri and token_uri must be valid HTTPS URLs.'
			};
		}

		return {
			isValid: true,
			message: 'Valid service account JSON'
		};
	};

	const handleSave = (skipUpload = false) => {
		// Allow skipping the JSON upload step
		if (skipUpload) {
			setStep(2);
			return;
		}

		if (jsonContent) {
			// Validate JSON content
			try {
				// Check if jsonContent is a valid object
				if (typeof jsonContent !== 'object' || jsonContent === null) {
					toast.error('Invalid JSON file. Please upload a valid JSON file.');
					return;
				}

				// Validate Firebase service account JSON structure
				const validation = validateServiceAccountJSON(jsonContent);
				if (!validation.isValid) {
					toast.error(validation.message);
					return;
				}

				let data = {
					id: id,
					application_json: JSON.stringify(jsonContent),
					json_name: fileName,
					channel_type: channel_type
				}
				fetchWithAuth(Utils.baseurl + 'update/application', {
					method: 'POST',
					body: JSON.stringify(data),
				})
					.then((response) => response.json())
					.then(async (result) => {
						if (result.status) {
							setStep(2)
						} else {
							toast.error(result.message)
						}
					})
					.catch((error) => {
						console.error(error);
						toast.error('Failed to save configuration. Please try again.');
					});
			} catch (error) {
				toast.error('Invalid JSON file. Please upload a valid JSON file.');
				console.error('JSON validation error:', error);
			}
		} else {
			if (!jsonName) {
				// If no JSON uploaded, allow proceeding to next step
				setStep(2);
			} else {
				setStep(2)
			}
		}
	};


	function handleConfigType() {

		if (appConfigType && !appExist) {

			fetchWithAuth(Utils.baseurl + 'update/application', {
				method: 'POST',
				body: JSON.stringify({ app_config_type: appConfigType, id: id, channel_type: channel_type }),
			})
				.then((response) => response.json())
				.then(async (result) => {
					if (result.status) {
						setStep(3)
					} else {
						toast.error(result.message)
					}
				})
				.catch((error) => console.error(error));

		} else {
			if (!appExist) {
				setAppConfigTypeAlert(true)
			} else {
				setStep(3)
			}
		}

	}


	useEffect(() => {
		if (appConfigType) {
			setAppConfigTypeAlert(false)
		}
		if (jsonContent) {
			setShowJsonAlert(false)
		}
		if (jsonName) {
			setShowJsonAlert(false)
		}
	}, [appConfigType, jsonContent, jsonName]);

	const handleCopy = () => {
		const appId = randomStr || id;
		navigator.clipboard.writeText(appId)
			.then(() => {
				toast.success('Copied to clipboard!');
			})
			.catch((err) => {
				console.error('Failed to copy text: ', err);
			});
	};

	function handleDoneSetup() {
		localStorage.setItem('currentSidebar', "dashboardSidebar");
		changeSidebar('dashboardSidebar', 0)
		navigate(`/apps/${id}`)
	}

	function handleFirstGoback() {
		localStorage.setItem("thirdSidebar", 0)
		let currentSidebarState = localStorage.getItem("currentSidebar")
		let activeAppState = localStorage.getItem("activeApp")
		if (currentSidebarState === "dashboardSidebar") {
			navigate(`/apps/${activeAppState}/platform`)
			changeSidebar('dashboardSidebar', 0)
		} else {
			navigate(`/apps/new`)
			changeSidebar('defaultSidebar', 0)
		}
	}

	return (
		<div className="dashboard_right">
			{
				Number(channel_type) === 1 && Number(step) === 1 ?
					// <div className="dashboard_inner configuration_page">
					// 	<div className="dashboard_top">
					// 		<div className="dashboard_heading">
					// 			<h1>New notifySphere App</h1>
					// 		</div>
					// 	</div>
					// 	<div className="steps_outer">
					// 		<div className="app_setting_steps_inner">
					// 			<div className="app_setting_steps_form_outer">
					// 				<div className="app_setting_steps_left">
					// 					<div className="app_setting_steps_sub_heading">
					// 						Please answer a few short questions so we can customize your notifySphere experience.
					// 					</div>
					// 					<div className="steps_form">
					// 						<div className="category_field">
					// 							<label for="company-role">APNs Authentication Type</label>
					// 							<div className="select_field">
					// 								<select className="" name="">
					// 									<option value="">Select...</option>
					// 									<option value="">APNs Authentication Type</option>
					// 								</select>
					// 							</div>
					// 							<div className="validation_error">
					// 								<span>
					// 									<img src="error_icon.svg" alt="" />
					// 									Please enter a response</span>
					// 							</div>
					// 						</div>
					// 						<div className="upload_file">
					// 							<div className="category_field">
					// 								<label>Key (.p8 file)</label>
					// 								<div className="file_type">
					// 									<input type="file" name="" value="" />
					// 								</div>
					// 							</div>
					// 						</div>
					// 						<div className="field_name">
					// 							<label for="Key ID">Key ID</label>
					// 							<div className="input_field">
					// 								<input type="text" value="" />
					// 							</div>
					// 							<div className="validation_error">
					// 								<span><img src="error_icon.svg" alt="" />
					// 									Please enter a response</span>
					// 							</div>
					// 						</div>
					// 						<div className="field_name">
					// 							<label for="Team ID">Team ID</label>
					// 							<div className="input_field">
					// 								<input type="text" value="" />
					// 							</div>
					// 							<div className="validation_error">
					// 								<span>
					// 									<img src="error_icon.svg" alt="" />
					// 									Please enter a response</span>
					// 							</div>
					// 						</div>
					// 						<div className="field_name">
					// 							<label for="App Bundle ID">App Bundle ID</label>
					// 							<div className="input_field">
					// 								<input type="text" value="" />
					// 							</div>
					// 							<div className="validation_error">
					// 								<span>
					// 									<img src="error_icon.svg" alt="" />
					// 									Please enter a response</span>
					// 							</div>
					// 						</div>
					// 						<div className="select_apply_section">
					// 							<div className="select_boxes">
					// 								<div className="select_box">
					// 									<input id="" type="checkbox" />
					// 									<label for="I don't have a website">
					// 										<span>Enable iOS 12 direct to history</span>
					// 									</label>
					// 								</div>
					// 							</div>
					// 						</div>

					// 					</div>
					// 				</div>
					// 				<div className="steps_right">
					// 					<div className="step_right_heading">0/4 Steps Completed</div>
					// 					<div className="step_progress">
					// 						<div className="progress_bar">
					// 						</div>
					// 					</div>
					// 					<div className="step_listing">
					// 						<div className="step_list">
					// 							<div className="count_circle">
					// 								<div className="step_count">1</div>
					// 								<div className="step_seperator"></div>
					// 							</div>
					// 							<label>New App</label>
					// 						</div>
					// 						<div className="step_list active">
					// 							<div className="count_circle">
					// 								<div className="step_count">2</div>
					// 								<div className="step_seperator"></div>
					// 							</div>
					// 							<label>Create Organization</label>
					// 						</div>
					// 						<div className="step_list">
					// 							<div className="count_circle">
					// 								<div className="step_count">3</div>
					// 								<div className="step_seperator"></div>
					// 							</div>
					// 							<label>Select SDK</label>
					// 						</div>
					// 						<div className="step_list">
					// 							<div className="count_circle">
					// 								<div className="step_count">4</div>
					// 							</div>
					// 							<label>Install and Test</label>
					// 						</div>
					// 					</div>
					// 				</div>
					// 			</div>
					// 		</div>
					// 	</div>
					// 	<div className="next_button">
					// 		<button type="button" name="button">Save & Continue</button>
					// 		<button className="go_back" type="button" name="button" onClick={() => navigate("/apps/new")} >Go Back</button>
					// 	</div>
					// </div>
					<div className="dashboard_right">
						<div className="dashboard_inner configuration_page">
							<div className="dashboard_top">
								<div className="dashboard_heading">
									<h1>New notifySphere App</h1>
								</div>
							</div>
							<div className="app_setting_steps_outer">
								<div className="app_setting_steps_inner">
									<div className="app_setting_steps_form_outer app_setting_step_1">
										<div className="app_setting_steps_left">
											<div className="steps_sub_heading">
												Now, let's configure your app. <a href={getMarketingUrl('/docs/firebase-credentials')} target="_blank" rel="noopener noreferrer">Read our iOS documentation</a> to learn how to complete the fields below.
											</div>
											<div className="steps_form">
												<div className="upload_file">
													<div className="category_field">
														<label>Service Account JSON <span style={{ color: '#888', fontWeight: 'normal', fontSize: '12px' }}>(Optional - can be configured later)</span></label>
														<div className="file_type">
															<input type="file" onChange={handleFileUpload} accept="application/json" />
														</div>
													</div>
												</div>
												{fileName.length || jsonName ? <div className="upload_file">
													<div >
														<label>Firebase Project ID</label>
														<div className="file_type" disabled={true} style={{ backgroundColor: "#eee", cursor: "not-allowed" }}>
															<b style={{ opacity: 0.8 }}>

																{fileName.length ? fileName.slice(0, fileName.length - 5) : jsonName.slice(0, fileName.length - 5)}
															</b>
														</div>
													</div>
												</div> : ""}
												<div className="retrieve_pera">
													<a href="https://console.firebase.google.com/" target="_blank" rel="noreferrer">
														<span>Retrieve from your Firebase Console</span>
													</a>
												</div>
											</div>
										</div>
										<div className="steps_right">
											<div className="step_right_heading">1/4 Steps Completed</div>
											<div className="step_progress">
												<div className="progress_bar">
												</div>
											</div>
											<div className="step_listing">
												<div className="step_list filled">
													<div className="count_circle">
														<div className="step_count">1</div>
														<div className="step_seperator"></div>
													</div>
													<label>New App</label>
												</div>
												<div className="step_list active">
													<div className="count_circle">
														<div className="step_count">2</div>
														<div className="step_seperator"></div>
													</div>
													<label>Configure App Settings</label>
												</div>
												<div className="step_list">
													<div className="count_circle">
														<div className="step_count">3</div>
														<div className="step_seperator"></div>
													</div>
													<label>Select SDK</label>
												</div>
												<div className="step_list">
													<div className="count_circle">
														<div className="step_count">4</div>
													</div>
													<label>Install and Test</label>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="next_button">
								{canManagePlatform ? (
								<button type="button" name="button" onClick={() => handleSave(false)}>{jsonContent || jsonName ? 'Save & Continue' : 'Skip & Continue'}</button>
								) : null} &nbsp;
								<button className="go_back" type="button" name="button" onClick={handleFirstGoback} >Go Back</button>
							</div>
						</div>
					</div>
					: Number(channel_type) === 1 && Number(step) === 2 ?
						<div className="dashboard_right">
							<div className="dashboard_inner configuration_page">
								<div className="dashboard_top">
									<div className="dashboard_heading">
										<h1>Google Android Configuration</h1>
									</div>
								</div>
								<div className="app_setting_steps_outer app_setting_step_2">
									<div className="app_setting_steps_inner">
										<div className="app_setting_steps_form_outer">
											<div className="app_setting_steps_left">
												<div className="steps_sub_heading">
													Select your target SDK. We'll take you through the steps to get your first user & send your first test notification.
												</div>
												<div className="app_select_field">
													<div className="app_field_inner">
														<label></label>
														<div className="select_app">
															<ul>
																<li>
																	<input type="radio" name="radio" value="apple" onChange={() => setAppConfigType(1)} checked={appConfigType === 1} />
																	<div className="select_inner">
																		<svg style={{ height: "50px", width: "50%" }} viewBox="0 0 1274.37 718" fill="currentColor" className="sc-jSMfEi hKsxtk"><path d="m930.77 536.42a53.07 53.07 0 1 1 53.06-53.08 53.14 53.14 0 0 1 -53.06 53.08m-586.54 0a53.07 53.07 0 1 1 53.06-53.08 53.13 53.13 0 0 1 -53.06 53.08m605.57-319.65 106.05-183.68a22.06 22.06 0 1 0 -38.21-22.09l-107.39 186c-82.12-37.48-174.35-58.35-272.76-58.35s-190.63 20.9-272.75 58.35l-107.38-186a22.06 22.06 0 1 0 -38.22 22.06l106.06 183.71c-182.11 99.05-306.67 283.41-324.89 501.23h1274.38c-18.24-217.82-142.79-402.18-324.89-501.23" fill="#3ddc84"></path></svg>
																		<span style={{ marginTop: "10px" }}>Native Android</span>
																	</div>
																</li>
																<li>
																	<input type="radio" name="radio" value="web" onChange={() => setAppConfigType(2)} checked={appConfigType === 2} />
																	<div className="select_inner">
																		<svg style={{ height: "50px", width: "50%" }} viewBox="0 0 48 48" fill="currentColor" className="sc-jSMfEi hKsxtk"><path fillRule="evenodd" clipRule="evenodd" d="M47.863 24.317c0-3.17-3.97-6.175-10.058-8.039 1.405-6.205.78-11.141-1.97-12.722-.633-.37-1.37-.545-2.177-.546V3c-2.682 0-6.195 1.912-9.746 5.23-3.551-3.298-7.063-5.191-9.746-5.191v.01c-.82 0-1.561.175-2.205.546-2.741 1.58-3.356 6.507-1.941 12.693C3.95 18.16 0 21.156 0 24.318c0 3.17 3.97 6.175 10.059 8.038-1.405 6.205-.78 11.142 1.97 12.722.634.37 1.376.546 2.195.546 2.683 0 6.195-1.912 9.747-5.229 3.551 3.298 7.063 5.19 9.746 5.19.82 0 1.561-.175 2.205-.546 2.741-1.58 3.356-6.507 1.941-12.693 6.05-1.863 10-4.868 10-8.029zm-22.4-14.566C28.64 6.8 31.62 5.181 33.65 5.176v.01c.449 0 .81.087 1.112.253 1.327.761 1.902 3.659 1.454 7.385a30.04 30.04 0 01-.498 2.869c-1.912-.469-4-.83-6.195-1.064a47.597 47.597 0 00-4.059-4.878zM14.166 5.215c2.02 0 5.014 1.61 8.195 4.546a46.074 46.074 0 00-4.03 4.868 45.56 45.56 0 00-6.204 1.073 29.437 29.437 0 01-.508-2.829c-.458-3.727.108-6.624 1.425-7.395.293-.176.673-.254 1.122-.254v-.01zM35.16 17.81a43.95 43.95 0 01-1.317 3.854c-.4-.78-.82-1.561-1.278-2.342a52.874 52.874 0 00-1.405-2.283c1.385.205 2.722.459 4 .771zm-6.82 14.117a52.005 52.005 0 004.37-7.62 50.789 50.789 0 00-2.029-3.883 53.782 53.782 0 00-2.36-3.707 50.733 50.733 0 00-8.8.01 51.91 51.91 0 00-2.352 3.727 50.845 50.845 0 00-2.02 3.892 50.823 50.823 0 002.03 3.883 53.758 53.758 0 002.36 3.707 50.775 50.775 0 008.8-.01zm5.503-4.996a41.807 41.807 0 011.346 3.883 43.783 43.783 0 01-4.02.78c.479-.75.957-1.521 1.405-2.311.45-.78.869-1.571 1.269-2.352zM21.239 34.22a40.246 40.246 0 002.712 3.122 38.075 38.075 0 002.683-3.122c-.887.049-1.795.068-2.712.068-.907 0-1.805-.029-2.683-.068zm-4.546-2.625a44.037 44.037 0 01-4-.77c.361-1.259.81-2.556 1.317-3.854.4.78.82 1.56 1.278 2.341.459.78.927 1.542 1.405 2.283zm9.921-17.18a40.204 40.204 0 00-2.712-3.122 38.114 38.114 0 00-2.683 3.121 49.551 49.551 0 012.712-.068c.908 0 1.805.03 2.683.068zm-9.931 2.624a53.942 53.942 0 00-2.674 4.654 41.807 41.807 0 01-1.346-3.883 47.362 47.362 0 014.02-.77zM2.166 24.317c0 1.532 2.234 3.463 5.687 4.936.85.361 1.766.693 2.732.995a46.203 46.203 0 012.166-5.912 46.857 46.857 0 01-2.195-5.941c-.947.302-1.864.624-2.703.985-3.453 1.464-5.687 3.405-5.687 4.937zm10.936 18.878c-1.326-.76-1.902-3.658-1.453-7.385.107-.917.283-1.883.497-2.869 1.913.469 4 .83 6.196 1.064a47.585 47.585 0 004.058 4.878c-3.18 2.956-6.166 4.575-8.195 4.575-.44-.01-.81-.097-1.103-.263zm21.717-.039c1.318-.77 1.883-3.668 1.425-7.395a27.306 27.306 0 00-.507-2.839c-1.913.478-4 .84-6.205 1.073a46.082 46.082 0 01-4.03 4.869c3.18 2.936 6.176 4.546 8.196 4.546.448 0 .829-.078 1.121-.254zM40 29.253c-.839.361-1.756.683-2.702.986a46.86 46.86 0 00-2.196-5.942c.898-2.029 1.62-4.01 2.166-5.912.966.302 1.883.634 2.742.995 3.454 1.473 5.688 3.405 5.688 4.937-.01 1.532-2.244 3.473-5.698 4.936zm-11.62-4.936a4.459 4.459 0 11-8.917 0 4.459 4.459 0 018.918 0z" fill="#00D8FF"></path></svg>
																		<span style={{ marginTop: "10px" }}>React Native </span>
																	</div>
																</li>
																<li>
																	<input type="radio" name="radio" value="email" onChange={() => setAppConfigType(3)} checked={appConfigType === 3} />
																	<div className="select_inner">
																		<svg style={{ height: "50px", width: "50%" }} viewBox="0 0 48 48" fill="currentColor" className="sc-jSMfEi hKsxtk"><path d="M12.392 31.39L5 23.998 29 0h14.781l-31.39 31.39zm31.389-9.245H29l-5.537 5.537 7.392 7.392" fill="#42A5F5" fill-opacity="0.8"></path><path d="M23.463 42.463L29 48h14.78L30.855 35.074" fill="#0D47A1"></path><path d="M16.089 35.077l7.38-7.381 7.38 7.38-7.38 7.381-7.38-7.38z" fill="#42A5F5"></path><path d="M23.47 42.457l7.38-7.38 1.03 1.03-7.38 7.38-1.03-1.03z" fill="url(#4bf1ecc6-bea9-416d-a9b2-f15f7e41b9a1_paint0_linear)"></path><path d="M23.463 42.463l10.967-3.789-3.576-3.602" fill="url(#4bf1ecc6-bea9-416d-a9b2-f15f7e41b9a1_paint1_linear)"></path><defs><linearGradient id="4bf1ecc6-bea9-416d-a9b2-f15f7e41b9a1_paint0_linear" x1="27.161" y1="38.766" x2="28.191" y2="39.796" gradientUnits="userSpaceOnUse"><stop offset="0.2" stop-opacity="0.15"></stop><stop offset="0.85" stop-color="#616161" stop-opacity="0.01"></stop></linearGradient><linearGradient id="4bf1ecc6-bea9-416d-a9b2-f15f7e41b9a1_paint1_linear" x1="23.465" y1="38.768" x2="34.432" y2="38.768" gradientUnits="userSpaceOnUse"><stop offset="0.2" stop-opacity="0.55"></stop><stop offset="0.85" stop-color="#616161" stop-opacity="0.01"></stop></linearGradient></defs></svg>
																		<span style={{ marginTop: "10px" }}>Flutter</span>
																	</div>
																</li>
															</ul>
															{appConfigTypeAlert ? <span style={{ color: "red" }}>Please enter a response</span> : ""}
														</div>
														{/* <div className="need_help">
														<div><b>Need help?</b> Invite a teammate to complete this step.</div>
														<button className="sc-fnykZs cTtTIm" fdprocessedid="lggph6">
															<svg viewBox="0 0 16 16" fill="currentColor" ><g fill="currentColor"><path d="M0 8a1 1 0 001 1h5.833A.167.167 0 017 9.167V15a1 1 0 102 0V9.167A.167.167 0 019.167 9H15a1 1 0 100-2H9.167A.167.167 0 019 6.833V1a1 1 0 00-2 0v5.833A.167.167 0 016.833 7H1a1 1 0 00-1 1z"></path></g></svg>
															<span>Invite</span>
														</button>
													</div> */}
													</div>
												</div>
											</div>
											<div className="steps_right">
												<div className="step_right_heading">2/4 Steps Completed</div>
												<div className="step_progress">
													<div className="progress_bar">
													</div>
												</div>
												<div className="step_listing">
													<div className="step_list filled">
														<div className="count_circle">
															<div className="step_count">1</div>
															<div className="step_seperator"></div>
														</div>
														<label>New App</label>
													</div>
													<div className="step_list filled">
														<div className="count_circle">
															<div className="step_count">2</div>
															<div className="step_seperator"></div>
														</div>
														<label>Create Organization</label>
													</div>
													<div className="step_list active">
														<div className="count_circle">
															<div className="step_count">3</div>
															<div className="step_seperator"></div>
														</div>
														<label>Select SDK</label>
													</div>
													<div className="step_list">
														<div className="count_circle">
															<div className="step_count">4</div>
														</div>
														<label>Install and Test</label>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="next_button">
									{canManagePlatform ? (
									<button type="button" name="button" onClick={handleConfigType} >Save & Continue</button>
									) : null} &nbsp;
									<button className="go_back" type="button" name="button" onClick={() => setStep(1)}>Go Back</button>
								</div>
							</div>
						</div> :
						Number(channel_type) === 1 && Number(step) === 3 ?
							<div className="dashboard_right">
								<div className="dashboard_inner configuration_page">
									<div className="dashboard_top">
										<div className="dashboard_heading">
											<h1>Google Android Configuration</h1>
										</div>
									</div>
									<div className="app_setting_steps_outer app_setting_step_3">
										<div className="app_setting_steps_inner">
											<div className="app_setting_steps_form_outer">
												<div className="app_setting_steps_left">
													<div className="sdk_outer">
														<div>
															<h2>1. Install the SDK</h2>
															<span>Read our <button type="button" className="link-btn">
																<span>React Native / Expo documentation</span>
															</button> to learn how to install the SDK.</span>
														</div>
														<span>Your App ID: <code>{randomStr || id}</code>
															<button type="button" onClick={handleCopy}>
																<svg viewBox="0 0 16 16" fill="currentColor">
																	<path fill="currentColor" fillRule="evenodd" d="M7 9h7V2H7v7Zm-1.621 1.621c.243.243.572.379.915.379h8.412A1.294 1.294 0 0 0 16 9.706V1.294A1.294 1.294 0 0 0 14.706 0H6.294A1.294 1.294 0 0 0 5 1.294v8.412c0 .343.136.672.379.915Z" clipRule="evenodd">
																	</path>
																	<path fill="currentColor" d="M9.666 16a1.666 1.666 0 0 0 1.667-1.667v-1.22a.665.665 0 0 0-.667-.78H5A1.333 1.333 0 0 1 3.667 11V5.333A.667.667 0 0 0 3 4.667H1.667A1.667 1.667 0 0 0 0 6.333v8A1.667 1.667 0 0 0 1.667 16h8Z">
																	</path>
																</svg>
															</button>
														</span>
														<div>
															<h2>2. Test for Subscribed Users</h2>
															<span>Build and run your app. The OneSignal SDK, once set up correctly, will automatically handle subscribing your device to notifications.</span>
														</div>
														<div className="check_subscribe">
															<button type="button">
																<svg viewBox="0 0 16 16" fill="currentColor">
																	<path d="M6.711 2.652a5.489 5.489 0 00-4.044 4.05 5.513 5.513 0 00.104 2.968.167.167 0 00.25.089l.893-.588a.667.667 0 011.02.692l-.61 2.937a.667.667 0 01-.786.52L.6 12.713a.667.667 0 01-.232-1.21l.933-.615a.166.166 0 00.063-.2 7.167 7.167 0 018.828-9.516.833.833 0 01-.507 1.587 5.489 5.489 0 00-2.974-.108zM15.75 3.542c.09.096.15.216.172.346a.667.667 0 01-.301.681l-.898.564a.166.166 0 00-.066.2 7.167 7.167 0 01-8.77 9.514.835.835 0 01-.154-1.544.831.831 0 01.646-.048 5.5 5.5 0 006.856-6.949.167.167 0 00-.176-.114.164.164 0 00-.071.026l-.962.604a.667.667 0 01-1.005-.713l.667-2.924a.667.667 0 01.8-.502l2.925.667c.129.03.246.096.336.192z" fill="currentColor">
																	</path>
																</svg>
																<span>Check Subscribed Users</span>
															</button>
														</div>
													</div>
													{/* <div className="need_help">
													<div><b>Need help?</b> Invite a teammate to complete this step.</div>
													<button className="sc-fnykZs cTtTIm" fdprocessedid="lggph6">
														<svg viewBox="0 0 16 16" fill="currentColor" ><g fill="currentColor"><path d="M0 8a1 1 0 001 1h5.833A.167.167 0 017 9.167V15a1 1 0 102 0V9.167A.167.167 0 019.167 9H15a1 1 0 100-2H9.167A.167.167 0 019 6.833V1a1 1 0 00-2 0v5.833A.167.167 0 016.833 7H1a1 1 0 00-1 1z"></path></g></svg>
														<span>Invite</span>
													</button>
												</div> */}
												</div>
												<div className="steps_right">
													<div className="step_right_heading">3/4 Steps Completed</div>
													<div className="step_progress">
														<div className="progress_bar">
														</div>
													</div>
													<div className="step_listing">
														<div className="step_list filled">
															<div className="count_circle">
																<div className="step_count">1</div>
																<div className="step_seperator"></div>
															</div>
															<label>New App</label>
														</div>
														<div className="step_list filled">
															<div className="count_circle">
																<div className="step_count">2</div>
																<div className="step_seperator"></div>
															</div>
															<label>Create Organization</label>
														</div>
														<div className="step_list filled">
															<div className="count_circle">
																<div className="step_count">3</div>
																<div className="step_seperator"></div>
															</div>
															<label>Select SDK</label>
														</div>
														<div className="step_list active">
															<div className="count_circle">
																<div className="step_count">4</div>
															</div>
															<label>Install and Test</label>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="next_button">
										<button type="button" name="button" onClick={handleDoneSetup} >Done</button> &nbsp;
										<button className="go_back" type="button" name="button" onClick={() => setStep(2)}>Go Back</button>
									</div>
								</div>
							</div> :





							Number(channel_type) === 2 && Number(step) === 1 ?
								<div className="dashboard_right">
									<div className="dashboard_inner configuration_page">
										<div className="dashboard_top">
											<div className="dashboard_heading">
												<h1>New notifySphere App</h1>
											</div>
										</div>
										<div className="app_setting_steps_outer">
											<div className="app_setting_steps_inner">
												<div className="app_setting_steps_form_outer app_setting_step_1">
													<div className="app_setting_steps_left">
														<div className="steps_sub_heading">
															Now, let's configure your app. <a href={getMarketingUrl('/docs/firebase-credentials')} target="_blank" rel="noopener noreferrer">Read our Android documentation</a> to learn how to complete the fields below.
														</div>
														<div className="steps_form">
															<div className="upload_file">
																<div className="category_field">
																	<label>Service Account JSON <span style={{ color: '#888', fontWeight: 'normal', fontSize: '12px' }}>(Optional - can be configured later)</span></label>
																	<div className="file_type">
																		<input type="file" onChange={handleFileUpload} accept="application/json" />
																	</div>
																</div>
															</div>
															{fileName.length || jsonName ? <div className="upload_file">
																<div >
																	<label>Firebase Project ID</label>
																	<div className="file_type" disabled={true} style={{ backgroundColor: "#eee", cursor: "not-allowed" }}>
																		<b style={{ opacity: 0.8 }}>

																			{fileName.length ? fileName.slice(0, fileName.length - 5) : jsonName.slice(0, fileName.length - 5)}
																		</b>
																	</div>
																</div>
															</div> : ""}
															<div className="retrieve_pera">
																<a href="https://console.firebase.google.com/" target="_blank" rel="noreferrer">
																	<span>Retrieve from your Firebase Console</span>
																</a>
															</div>
															<div className="upload_file" style={{ marginTop: '20px' }}>
																<div>
																	<label>Your App ID</label>
																	<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
																		<div className="file_type" style={{ backgroundColor: "#eee", cursor: "default", flex: 1 }}>
																			<b style={{ opacity: 0.8 }}>
																				{randomStr || id || 'Loading...'}
																			</b>
																		</div>
																		<button type="button" onClick={handleCopy} style={{ padding: '8px 12px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff' }}>
																			<svg viewBox="0 0 16 16" fill="currentColor" style={{ width: '16px', height: '16px' }}>
																				<path fill="currentColor" fillRule="evenodd" d="M7 9h7V2H7v7Zm-1.621 1.621c.243.243.572.379.915.379h8.412A1.294 1.294 0 0 0 16 9.706V1.294A1.294 1.294 0 0 0 14.706 0H6.294A1.294 1.294 0 0 0 5 1.294v8.412c0 .343.136.672.379.915Z" clipRule="evenodd">
																				</path>
																				<path fill="currentColor" d="M9.666 16a1.666 1.666 0 0 0 1.667-1.667v-1.22a.665.665 0 0 0-.667-.78H5A1.333 1.333 0 0 1 3.667 11V5.333A.667.667 0 0 0 3 4.667H1.667A1.667 1.667 0 0 0 0 6.333v8A1.667 1.667 0 0 0 1.667 16h8Z">
																				</path>
																			</svg>
																		</button>
																	</div>
																</div>
															</div>

														</div>
													</div>
													<div className="steps_right">
														<div className="step_right_heading">1/4 Steps Completed</div>
														<div className="step_progress">
															<div className="progress_bar">
															</div>
														</div>
														<div className="step_listing">
															<div className="step_list filled">
																<div className="count_circle">
																	<div className="step_count">1</div>
																	<div className="step_seperator"></div>
																</div>
																<label>New App</label>
															</div>
															<div className="step_list active">
																<div className="count_circle">
																	<div className="step_count">2</div>
																	<div className="step_seperator"></div>
																</div>
																<label>Configure App Settings</label>
															</div>
															<div className="step_list">
																<div className="count_circle">
																	<div className="step_count">3</div>
																	<div className="step_seperator"></div>
																</div>
																<label>Select SDK</label>
															</div>
															<div className="step_list">
																<div className="count_circle">
																	<div className="step_count">4</div>
																</div>
																<label>Install and Test</label>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="next_button">
											{canManagePlatform ? (
											<button type="button" name="button" onClick={() => handleSave(false)}>{jsonContent || jsonName ? 'Save & Continue' : 'Skip & Continue'}</button>
											) : null} &nbsp;
											<button className="go_back" type="button" name="button" onClick={handleFirstGoback} >Go Back</button>
										</div>
									</div>
								</div> : Number(channel_type) === 2 && Number(step) === 2 ?
									<div className="dashboard_right">
										<div className="dashboard_inner configuration_page">
											<div className="dashboard_top">
												<div className="dashboard_heading">
													<h1>Google Android Configuration</h1>
												</div>
											</div>
											<div className="app_setting_steps_outer app_setting_step_2">
												<div className="app_setting_steps_inner">
													<div className="app_setting_steps_form_outer">
														<div className="app_setting_steps_left">
															<div className="steps_sub_heading">
																Select your target SDK. We'll take you through the steps to get your first user & send your first test notification.
															</div>
															<div className="app_select_field">
																<div className="app_field_inner">
																	<label></label>
																	<div className="select_app">
																		<ul>
																			<li>
																				<input type="radio" name="radio" value="2" onChange={() => setAppConfigType(2)} checked={appConfigType === 2} />
																				<div className="select_inner">
																					<svg style={{ height: "50px", width: "50%" }} viewBox="0 0 48 48" fill="currentColor" className="sc-jSMfEi hKsxtk"><path fillRule="evenodd" clipRule="evenodd" d="M47.863 24.317c0-3.17-3.97-6.175-10.058-8.039 1.405-6.205.78-11.141-1.97-12.722-.633-.37-1.37-.545-2.177-.546V3c-2.682 0-6.195 1.912-9.746 5.23-3.551-3.298-7.063-5.191-9.746-5.191v.01c-.82 0-1.561.175-2.205.546-2.741 1.58-3.356 6.507-1.941 12.693C3.95 18.16 0 21.156 0 24.318c0 3.17 3.97 6.175 10.059 8.038-1.405 6.205-.78 11.142 1.97 12.722.634.37 1.376.546 2.195.546 2.683 0 6.195-1.912 9.747-5.229 3.551 3.298 7.063 5.19 9.746 5.19.82 0 1.561-.175 2.205-.546 2.741-1.58 3.356-6.507 1.941-12.693 6.05-1.863 10-4.868 10-8.029zm-22.4-14.566C28.64 6.8 31.62 5.181 33.65 5.176v.01c.449 0 .81.087 1.112.253 1.327.761 1.902 3.659 1.454 7.385a30.04 30.04 0 01-.498 2.869c-1.912-.469-4-.83-6.195-1.064a47.597 47.597 0 00-4.059-4.878zM14.166 5.215c2.02 0 5.014 1.61 8.195 4.546a46.074 46.074 0 00-4.03 4.868 45.56 45.56 0 00-6.204 1.073 29.437 29.437 0 01-.508-2.829c-.458-3.727.108-6.624 1.425-7.395.293-.176.673-.254 1.122-.254v-.01zM35.16 17.81a43.95 43.95 0 01-1.317 3.854c-.4-.78-.82-1.561-1.278-2.342a52.874 52.874 0 00-1.405-2.283c1.385.205 2.722.459 4 .771zm-6.82 14.117a52.005 52.005 0 004.37-7.62 50.789 50.789 0 00-2.029-3.883 53.782 53.782 0 00-2.36-3.707 50.733 50.733 0 00-8.8.01 51.91 51.91 0 00-2.352 3.727 50.845 50.845 0 00-2.02 3.892 50.823 50.823 0 002.03 3.883 53.758 53.758 0 002.36 3.707 50.775 50.775 0 008.8-.01zm5.503-4.996a41.807 41.807 0 011.346 3.883 43.783 43.783 0 01-4.02.78c.479-.75.957-1.521 1.405-2.311.45-.78.869-1.571 1.269-2.352zM21.239 34.22a40.246 40.246 0 002.712 3.122 38.075 38.075 0 002.683-3.122c-.887.049-1.795.068-2.712.068-.907 0-1.805-.029-2.683-.068zm-4.546-2.625a44.037 44.037 0 01-4-.77c.361-1.259.81-2.556 1.317-3.854.4.78.82 1.56 1.278 2.341.459.78.927 1.542 1.405 2.283zm9.921-17.18a40.204 40.204 0 00-2.712-3.122 38.114 38.114 0 00-2.683 3.121 49.551 49.551 0 012.712-.068c.908 0 1.805.03 2.683.068zm-9.931 2.624a53.942 53.942 0 00-2.674 4.654 41.807 41.807 0 01-1.346-3.883 47.362 47.362 0 014.02-.77zM2.166 24.317c0 1.532 2.234 3.463 5.687 4.936.85.361 1.766.693 2.732.995a46.203 46.203 0 012.166-5.912 46.857 46.857 0 01-2.195-5.941c-.947.302-1.864.624-2.703.985-3.453 1.464-5.687 3.405-5.687 4.937zm10.936 18.878c-1.326-.76-1.902-3.658-1.453-7.385.107-.917.283-1.883.497-2.869 1.913.469 4 .83 6.196 1.064a47.585 47.585 0 004.058 4.878c-3.18 2.956-6.166 4.575-8.195 4.575-.44-.01-.81-.097-1.103-.263zm21.717-.039c1.318-.77 1.883-3.668 1.425-7.395a27.306 27.306 0 00-.507-2.839c-1.913.478-4 .84-6.205 1.073a46.082 46.082 0 01-4.03 4.869c3.18 2.936 6.176 4.546 8.196 4.546.448 0 .829-.078 1.121-.254zM40 29.253c-.839.361-1.756.683-2.702.986a46.86 46.86 0 00-2.196-5.942c.898-2.029 1.62-4.01 2.166-5.912.966.302 1.883.634 2.742.995 3.454 1.473 5.688 3.405 5.688 4.937-.01 1.532-2.244 3.473-5.698 4.936zm-11.62-4.936a4.459 4.459 0 11-8.917 0 4.459 4.459 0 018.918 0z" fill="#00D8FF"></path></svg>
																					<span style={{ marginTop: "10px" }}>React Native </span>
																				</div>
																			</li>
																		</ul>
																		{appConfigTypeAlert ? <span style={{ color: "red" }}>Please enter a response</span> : ""}
																	</div>
																	{/* <div className="need_help">
																<div><b>Need help?</b> Invite a teammate to complete this step.</div>
																<button className="sc-fnykZs cTtTIm" fdprocessedid="lggph6">
																	<svg viewBox="0 0 16 16" fill="currentColor" ><g fill="currentColor"><path d="M0 8a1 1 0 001 1h5.833A.167.167 0 017 9.167V15a1 1 0 102 0V9.167A.167.167 0 019.167 9H15a1 1 0 100-2H9.167A.167.167 0 019 6.833V1a1 1 0 00-2 0v5.833A.167.167 0 016.833 7H1a1 1 0 00-1 1z"></path></g></svg>
																	<span>Invite</span>
																</button>
															</div> */}
																</div>
															</div>
														</div>
														<div className="steps_right">
															<div className="step_right_heading">2/4 Steps Completed</div>
															<div className="step_progress">
																<div className="progress_bar">
																</div>
															</div>
															<div className="step_listing">
																<div className="step_list filled">
																	<div className="count_circle">
																		<div className="step_count">1</div>
																		<div className="step_seperator"></div>
																	</div>
																	<label>New App</label>
																</div>
																<div className="step_list filled">
																	<div className="count_circle">
																		<div className="step_count">2</div>
																		<div className="step_seperator"></div>
																	</div>
																	<label>Create Organization</label>
																</div>
																<div className="step_list active">
																	<div className="count_circle">
																		<div className="step_count">3</div>
																		<div className="step_seperator"></div>
																	</div>
																	<label>Select SDK</label>
																</div>
																<div className="step_list">
																	<div className="count_circle">
																		<div className="step_count">4</div>
																	</div>
																	<label>Install and Test</label>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="next_button">
												{canManagePlatform ? (
												<button type="button" name="button" onClick={handleConfigType} >Save & Continue</button>
												) : null} &nbsp;
												<button className="go_back" type="button" name="button" onClick={() => setStep(1)}>Go Back</button>
											</div>
										</div>
									</div> :
									Number(channel_type) === 2 && Number(step) === 3 ?
										<div className="dashboard_right">
											<div className="dashboard_inner configuration_page">
												<div className="dashboard_top">
													<div className="dashboard_heading">
														<h1>Google Android Configuration</h1>
													</div>
												</div>
												<div className="app_setting_steps_outer app_setting_step_3">
													<div className="app_setting_steps_inner">
														<div className="app_setting_steps_form_outer">
															<div className="app_setting_steps_left">
																<div className="sdk_outer">
																	<div>
																		<h2>1. Install the SDK</h2>
																		<span>Read our <button type="button" className="link-btn">
																			<span>React Native / Expo documentation</span>
																		</button> to learn how to install the SDK.</span>
																	</div>
																	<span>Your App ID: <code>{randomStr || id}</code>
																		<button type="button" onClick={handleCopy}>
																			<svg viewBox="0 0 16 16" fill="currentColor">
																				<path fill="currentColor" fillRule="evenodd" d="M7 9h7V2H7v7Zm-1.621 1.621c.243.243.572.379.915.379h8.412A1.294 1.294 0 0 0 16 9.706V1.294A1.294 1.294 0 0 0 14.706 0H6.294A1.294 1.294 0 0 0 5 1.294v8.412c0 .343.136.672.379.915Z" clipRule="evenodd">
																				</path>
																				<path fill="currentColor" d="M9.666 16a1.666 1.666 0 0 0 1.667-1.667v-1.22a.665.665 0 0 0-.667-.78H5A1.333 1.333 0 0 1 3.667 11V5.333A.667.667 0 0 0 3 4.667H1.667A1.667 1.667 0 0 0 0 6.333v8A1.667 1.667 0 0 0 1.667 16h8Z">
																				</path>
																			</svg>
																		</button>
																	</span>
																	<div>
																		<h2>2. Test for Subscribed Users</h2>
																		<span>Build and run your app. The OneSignal SDK, once set up correctly, will automatically handle subscribing your device to notifications.</span>
																	</div>
																	<div className="check_subscribe">
																		<button type="button">
																			<svg viewBox="0 0 16 16" fill="currentColor">
																				<path d="M6.711 2.652a5.489 5.489 0 00-4.044 4.05 5.513 5.513 0 00.104 2.968.167.167 0 00.25.089l.893-.588a.667.667 0 011.02.692l-.61 2.937a.667.667 0 01-.786.52L.6 12.713a.667.667 0 01-.232-1.21l.933-.615a.166.166 0 00.063-.2 7.167 7.167 0 018.828-9.516.833.833 0 01-.507 1.587 5.489 5.489 0 00-2.974-.108zM15.75 3.542c.09.096.15.216.172.346a.667.667 0 01-.301.681l-.898.564a.166.166 0 00-.066.2 7.167 7.167 0 01-8.77 9.514.835.835 0 01-.154-1.544.831.831 0 01.646-.048 5.5 5.5 0 006.856-6.949.167.167 0 00-.176-.114.164.164 0 00-.071.026l-.962.604a.667.667 0 01-1.005-.713l.667-2.924a.667.667 0 01.8-.502l2.925.667c.129.03.246.096.336.192z" fill="currentColor">
																				</path>
																			</svg>
																			<span>Check Subscribed Users</span>
																		</button>
																	</div>
																</div>
																{/* <div className="need_help">
															<div><b>Need help?</b> Invite a teammate to complete this step.</div>
															<button className="sc-fnykZs cTtTIm" fdprocessedid="lggph6">
																<svg viewBox="0 0 16 16" fill="currentColor" ><g fill="currentColor"><path d="M0 8a1 1 0 001 1h5.833A.167.167 0 017 9.167V15a1 1 0 102 0V9.167A.167.167 0 019.167 9H15a1 1 0 100-2H9.167A.167.167 0 019 6.833V1a1 1 0 00-2 0v5.833A.167.167 0 016.833 7H1a1 1 0 00-1 1z"></path></g></svg>
																<span>Invite</span>
															</button>
														</div> */}
															</div>
															<div className="steps_right">
																<div className="step_right_heading">3/4 Steps Completed</div>
																<div className="step_progress">
																	<div className="progress_bar">
																	</div>
																</div>
																<div className="step_listing">
																	<div className="step_list filled">
																		<div className="count_circle">
																			<div className="step_count">1</div>
																			<div className="step_seperator"></div>
																		</div>
																		<label>New App</label>
																	</div>
																	<div className="step_list filled">
																		<div className="count_circle">
																			<div className="step_count">2</div>
																			<div className="step_seperator"></div>
																		</div>
																		<label>Create Organization</label>
																	</div>
																	<div className="step_list filled">
																		<div className="count_circle">
																			<div className="step_count">3</div>
																			<div className="step_seperator"></div>
																		</div>
																		<label>Select SDK</label>
																	</div>
																	<div className="step_list active">
																		<div className="count_circle">
																			<div className="step_count">4</div>
																		</div>
																		<label>Install and Test</label>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="next_button">
													<button type="button" name="button" onClick={handleDoneSetup} >Done</button> &nbsp;
													<button className="go_back" type="button" name="button" onClick={() => setStep(2)}>Go Back</button>
												</div>
											</div>
										</div> :
										Number(channel_type) === 3 ? (
											<div className="dashboard_right">
												<div className="dashboard_inner configuration_page">
													<div className="dashboard_top">
														<div className="dashboard_heading">
															<h1>Web Push Configuration</h1>
														</div>
													</div>
													<div className="app_setting_steps_outer">
														<div className="app_setting_steps_inner">
															<div className="app_setting_steps_form_outer app_setting_step_1">
																<div className="app_setting_steps_left">
																	<div className="steps_sub_heading">
																		Configure your Web push app. You can upload Firebase service account JSON (optional) or configure later.
																	</div>
																	<div className="steps_form">
																		<div className="upload_file">
																			<div className="category_field">
																				<label>Service Account JSON <span style={{ color: '#888', fontWeight: 'normal', fontSize: '12px' }}>(Optional - can be configured later)</span></label>
																				<div className="file_type">
																					<input type="file" onChange={handleFileUpload} accept="application/json" />
																				</div>
																			</div>
																		</div>
																		{(fileName && fileName.length) || jsonName ? <div className="upload_file">
																			<div>
																				<label>Firebase Project ID</label>
																				<div className="file_type" style={{ backgroundColor: '#eee', cursor: 'not-allowed' }}>
																					<b style={{ opacity: 0.8 }}>
																						{fileName ? fileName.slice(0, fileName.length - 5) : (jsonName || '').slice(0, (jsonName || '').length - 5)}
																					</b>
																				</div>
																			</div>
																		</div> : ''}
																		<div className="retrieve_pera">
																			<a href="https://console.firebase.google.com/" target="_blank" rel="noreferrer">
																				<span>Retrieve from your Firebase Console</span>
																			</a>
																		</div>
																		<div className="upload_file" style={{ marginTop: '20px' }}>
																			<div>
																				<label>Your App ID</label>
																				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
																					<div className="file_type" style={{ backgroundColor: '#eee', cursor: 'default', flex: 1 }}>
																						<b style={{ opacity: 0.8 }}>{randomStr || id || 'Loading...'}</b>
																					</div>
																					<button type="button" onClick={handleCopy} style={{ padding: '8px 12px', cursor: 'pointer', border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#fff' }}>
																						<svg viewBox="0 0 16 16" fill="currentColor" style={{ width: '16px', height: '16px' }}>
																							<path fill="currentColor" fillRule="evenodd" d="M7 9h7V2H7v7Zm-1.621 1.621c.243.243.572.379.915.379h8.412A1.294 1.294 0 0 0 16 9.706V1.294A1.294 1.294 0 0 0 14.706 0H6.294A1.294 1.294 0 0 0 5 1.294v8.412c0 .343.136.672.379.915Z" clipRule="evenodd" />
																							<path fill="currentColor" d="M9.666 16a1.666 1.666 0 0 0 1.667-1.667v-1.22a.665.665 0 0 0-.667-.78H5A1.333 1.333 0 0 1 3.667 11V5.333A.667.667 0 0 0 3 4.667H1.667A1.667 1.667 0 0 0 0 6.333v8A1.667 1.667 0 0 0 1.667 16h8Z" />
																						</svg>
																					</button>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
																<div className="steps_right">
																	<div className="step_right_heading">Configure Web</div>
																	<div className="step_listing">
																		<div className="step_list active">
																			<div className="count_circle"><div className="step_count">1</div></div>
																			<label>Configure App Settings</label>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div className="next_button">
														{canManagePlatform ? (
														<button type="button" name="button" onClick={() => handleSave(false)}>{jsonContent || jsonName ? 'Save & Continue' : 'Skip & Continue'}</button>
														) : null} &nbsp;
														<button className="go_back" type="button" name="button" onClick={handleFirstGoback}>Go Back</button>
													</div>
												</div>
											</div>
										) : (
										<div>
											Unsupported platform configuration.
										</div>
										)

			}
		</div>
	);
};

export default AppSetting;

